var e = {
	today: {
		title: "Today",
		subtitle: "Arrivals, departures and rooms for one property, one day at a time.",
		boardError: "We couldn't load the rooms for this property.",
		retry: "Try again",
		noProperties: { body: "Add a property and its arrivals, departures and rooms appear here." }
	},
	toolbar: {
		propertyPlaceholder: "Choose a property",
		untitledProperty: "Untitled property",
		previousDay: "Previous day",
		nextDay: "Next day",
		today: "Today"
	},
	tabs: {
		label: "Front desk lists",
		arrivals: "Arrivals",
		arrivalsCount: "Arrivals ({{count}})",
		departures: "Departures",
		departuresCount: "Departures ({{count}})",
		inHouse: "In-house",
		inHouseCount: "In-house ({{count}})",
		stayOver: "Stay-overs",
		stayOverCount: "Stay-overs ({{count}})",
		rooms: "Rooms",
		roomsCount: "Rooms ({{count}})"
	},
	columns: {
		guest: "Guest",
		roomType: "Room type",
		room: "Room",
		nights: "Nights",
		party: "Party",
		status: "Status"
	},
	row: {
		unknownGuest: "Guest",
		noRoom: "No room",
		unnamedRoom: "Unnamed room",
		untitledRoomType: "Room type",
		ready: "Ready",
		outOfOrder: "Out of order",
		overdue: "Overdue",
		nights_one: "{{count}} night",
		nights_other: "{{count}} nights",
		guests_one: "{{count}} guest",
		guests_other: "{{count}} guests"
	},
	actions: {
		menu: "Actions for {{guest}}",
		checkIn: "Check in",
		checkOut: "Check out",
		noShow: "Mark as no-show",
		reassign: "Reassign room",
		openBooking: "Open booking"
	},
	toast: {
		checkedIn: "Checked in",
		checkedOut: "Checked out",
		noShowMarked: "Marked as a no-show",
		failedTitle: "That didn't go through",
		failedBody: "We couldn't update this booking. Try again."
	},
	noShow: {
		title: "Mark this stay as a no-show?",
		body: "The guest never arrived. The room is released for the remaining nights, and the stay can't be checked in after this.",
		reasonLabel: "Reason (optional)",
		reasonPlaceholder: "For example: the guest didn't arrive and couldn't be reached",
		reasonMax: "Keep the reason under 300 characters",
		confirm: "Mark as no-show"
	},
	empty: {
		arrivals: {
			title: "No arrivals",
			body: "No guests are due to arrive on this day."
		},
		departures: {
			title: "No departures",
			body: "No guests are due to leave on this day."
		},
		inHouse: {
			title: "Nobody in-house",
			body: "No stays cover the night of this day."
		},
		stayOver: {
			title: "No stay-overs",
			body: "No guest arrived before this day and leaves after it."
		}
	},
	rooms: {
		freeTonight: "Free tonight",
		occupied: "Occupied",
		blocked: "Blocked",
		outOfOrder: "Out of order",
		overbookedTitle: "Overbooked nights ahead",
		overbooked_one: "{{date}} · {{count}} room short",
		overbooked_other: "{{date}} · {{count}} rooms short",
		noOverbooking: "No overbooking in the next 7 nights",
		empty: {
			title: "No rooms on this property",
			body: "Rooms appear here once the property has room types with rooms."
		},
		attention: {
			title: "Needs attention",
			outOfOrder_one: "{{room}} is out of order with {{count}} stay booked",
			outOfOrder_other: "{{room}} is out of order with {{count}} stays booked",
			arrivalNotReady: "{{room}} isn't ready for today's arrival",
			openBooking: "Open booking",
			emptyTitle: "Nothing needs attention",
			emptyBody: "Every arrival has a ready room, and no out-of-order room holds a stay.",
			arrivalDirty: "{{room}} is still dirty and a guest arrives today",
			arrivalNotInspected: "{{room}} is clean but not inspected, and a guest arrives today"
		},
		board: {
			title: "Housekeeping",
			filters: {
				status: "Status",
				occupancy: "Occupancy",
				myRooms: "My rooms",
				all: "All",
				search: "Search rooms",
				allStatuses: "All statuses",
				anyOccupancy: "Any occupancy"
			},
			occupancy: {
				arriving: "Arriving",
				departing: "Departing",
				stayOver: "Stay-over",
				vacant: "Vacant",
				outOfOrder: "Out of order",
				turnover: "Turnover"
			},
			actions: {
				markDirty: "Mark dirty",
				markClean: "Mark clean",
				markInspected: "Mark inspected",
				assign: "Assign",
				unassign: "Unassign",
				addNote: "Add note",
				editNote: "Edit note",
				menu: "Housekeeping actions for {{room}}"
			},
			assign: {
				title: "Assign rooms",
				search: "Search team members",
				unassigned: "Not assigned",
				apply: "Assign",
				titleOne: "Assign {{room}}",
				titleMany_one: "Assign {{count}} room",
				titleMany_other: "Assign {{count}} rooms",
				member: "Team member",
				memberRequired: "Choose a team member.",
				noMembers: "No team members to assign yet.",
				currentlyAssigned: "Currently assigned to {{name}}"
			},
			note: {
				title: "Room note",
				placeholder: "For example: the bathroom lamp needs replacing",
				save: "Save note",
				label: "Note",
				hint: "Leave it empty to remove the note.",
				tooLong: "Keep the note under 500 characters.",
				titleFor: "Note for {{room}}"
			},
			toast: {
				statusSaved: "Room status updated",
				assigned: "Rooms assigned",
				unassigned: "Rooms unassigned",
				noteSaved: "Note saved",
				failedTitle: "That didn't go through",
				failedBody: "We couldn't update this room. Try again.",
				noteCleared: "Note removed"
			},
			refusal: {
				ROOM_NOT_FOUND: "This room is no longer part of this property.",
				HOUSEKEEPING_INVALID_TRANSITION: "Only a clean room can be inspected. Mark it clean first.",
				ASSIGNEE_NOT_A_MEMBER: "That person is no longer on your team."
			},
			empty: {
				noRooms: "This property has no rooms to clean yet.",
				noMatch: "No rooms match these filters.",
				noRoomsBody: "Rooms appear here once the property has room types with rooms.",
				noMatchBody: "Change or clear a filter to see more rooms."
			},
			columns: {
				room: "Room",
				status: "Status",
				occupancy: "Today",
				assignee: "Assigned to",
				note: "Note",
				changed: "Last change"
			},
			assignee: {
				you: "You",
				someone: "A team member"
			},
			changed: { never: "Not changed yet" },
			group: { statusCount: "{{status}} · {{count}}" },
			selection: {
				count_one: "{{count}} room selected",
				count_other: "{{count}} rooms selected",
				assign_one: "Assign {{count}} room",
				assign_other: "Assign {{count}} rooms",
				unassign: "Unassign",
				clear: "Clear selection"
			}
		}
	},
	widget: {
		title: "Today",
		titleProperty: "Today at {{property}}",
		arrivals: "Arrivals",
		departures: "Departures",
		inHouse: "In-house",
		freeTonight: "Rooms free tonight",
		open: "Open Today"
	},
	operations: {
		title: "Operations",
		description: "How rooms are turned over across every property in this workspace.",
		cardTitle: "Housekeeping",
		cardDescription: "These rules decide when a room counts as ready for an arriving guest.",
		inspectionLabel: "Require an inspection before a room is ready",
		inspectionDescription: "A cleaned room counts as ready for an arrival only once someone has inspected it.",
		vacantLabel: "Mark a vacant room dirty after (days)",
		vacantHint: "A room left empty this many days needs cleaning again. 0 turns this off.",
		vacantRange: "Enter a whole number of days from 0 to 60",
		saved: "Operations settings saved",
		saveFailed: "We couldn't save the settings. Try again."
	}
};
//#endregion
export { e as default };
